import type { RouteRecordMainRaw } from '@fantastic-admin/types'
import type { RouteRecordRaw } from 'vue-router'
import pinia from '@/store'
import Account from './modules/account'
import AiCam from './modules/ai-cam'
import Community from './modules/community'
import Device from './modules/device'
import Docs from './modules/docs'
import Model from './modules/model'
import ThreeD from './modules/three-d'

// 固定路由（默认路由）
const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/account-redirect.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/',
    redirect: '/console',
  },
  {
    path: '/:all(.*)*',
    name: 'notFound',
    component: () => import('@/views/[...all].vue'),
    meta: {
      title: '找不到页面',
    },
  },
]

// 系统路由
const systemRoutes: RouteRecordRaw[] = [
  {
    path: '/console',
    component: () => import('@/layouts/index.vue'),
    meta: {
      breadcrumb: false,
    },
    children: [
      {
        path: '',
        component: () => import('@/views/index.vue'),
        meta: {
          title: useAppSettingsStore(pinia).settings.app.home.title,
          icon: 'i-ant-design:home-twotone',
          breadcrumb: false,
        },
      },
      {
        path: 'reload',
        name: 'reload',
        component: () => import('@/views/reload.vue'),
        meta: {
          title: '重新加载中...',
          breadcrumb: false,
        },
      },
    ],
  },
]

// 动态路由（异步路由、导航菜单路由）
const asyncRoutes: RouteRecordMainRaw[] = [
  {
    meta: {
      title: '设备',
      icon: 'i-mdi:robot-industrial-outline',
    },
    children: Device,
  },
  {
    meta: {
      title: '社区',
      icon: 'i-icon-park-outline:circular-connection',
    },
    children: [
      Community,
    ],
  },
  {
    meta: {
      title: '模型',
      icon: 'i-mdi:cube',
    },
    children: [
      Model,
    ],
  },
  {
    meta: {
      title: 'CAM',
      icon: 'i-mdi:shape',
    },
    children: [
      AiCam,
    ],
  },
  {
    meta: {
      title: '3D',
      icon: 'i-mdi:cube-outline',
    },
    children: [
      ThreeD,
    ],
  },
  {
    meta: {
      title: '文档',
      icon: 'i-mdi:file-document-outline',
    },
    children: [
      Docs,
    ],
  },
  {
    meta: {
      title: '账号',
      icon: 'i-mdi:account-circle',
    },
    children: Account,
  },
]

export {
  asyncRoutes,
  constantRoutes,
  systemRoutes,
}
